// ⚠️  GENERATED — do not edit. Run `npm run inferrex:generate` to regenerate.

// Source: inferrex-ai/classification/field-display-manifest.ts (cross-checked against the
// classification `fieldRoles` vocab). UI-only display treatment; the sensitivity vocab is
// shared from @inferrex/inference-schema. DisplayHue + HUE_CLASS live in ./field-display.ts.
import type { SensitivityClass } from '@inferrex/inference-schema';
import type { DisplayHue, RoleDisplay } from './field-display.js';

/** Semantic role → visual treatment (covers every classification role). */
export const ROLE_DISPLAY: Readonly<Record<string, RoleDisplay>> = {
  "attachment": {"hue":"neutral"},
  "classification": {"hue":"accent"},
  "collection": {"hue":"neutral"},
  "contact-point": {"hue":"info"},
  "credential": {"hue":"sensitive","emphasis":"sensitive","lock":true},
  "description-text": {"hue":"neutral"},
  "flag": {"hue":"accent"},
  "foreign-key": {"hue":"identifier"},
  "identifier": {"hue":"identifier","emphasis":"identifier"},
  "label": {"hue":"neutral"},
  "lifecycle-timestamp": {"hue":"warning"},
  "location-ref": {"hue":"info"},
  "monetary-amount": {"hue":"success"},
  "navigation": {"hue":"neutral"},
  "quantity": {"hue":"info"},
  "schema-meta": {"hue":"neutral"},
  "status-state": {"hue":"info"},
  "structure": {"hue":"neutral"},
  "ui-config": {"hue":"neutral"},
};

/** Sensitivity class → how a sensitive field/chip is shown. */
export const SENSITIVITY_DISPLAY: Readonly<Record<SensitivityClass, { readonly hue: DisplayHue; readonly lock: boolean }>> = {
  "credential": {"hue":"sensitive","lock":true},
  "financial": {"hue":"sensitive","lock":false},
  "health": {"hue":"sensitive","lock":false},
  "pii": {"hue":"sensitive","lock":false},
};
